;(function($){

    function Invoices() {
        var _                = this;         
        var data             = new FormData();
        _.API                = $("#app_url").val() + "/api/";
        _.oInvoices          = $("input[name='invoices[]']");
        _.total_value        = parseFloat(0);
        _.total_value_paid   = parseFloat(0);
        _.total_value_open   = parseFloat(0);

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        }); 

        $("#invoices-legend").on("click", function(e){
            e.preventDefault();

            swal({
              type: 'info',
              html:
                '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #4db300;"></i> Em Aberto </br>' +
                '<i class="fa fa-circle" style="color: #c33434;"></i> Pago </br>' +
                '<i class="fa fa-circle" style="color: #b4b4b4;"></i> Cancelado </div>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#539e30',
              confirmButtonText:
                'Fechar'
            });
        });       

        if($("#modal-invoice-create").length > 0) {

            $(document).on("change", "select#customers_id", function(){
                _.getContracts($(this).val());
            });
            
            $("#modal-invoice-create").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getCustomers();
                    _.getCostCenters();
                    _.getFinancialNatures();
                    _.getAccoutingItens();
                    _.getProjectTypes();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-invoice-create" enctype="multipart/form-data">' +
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="customers_id">Cliente</label>' +
                                '<select name="customers_id" id="customers_id" disabled></select>' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-6  col-md-6  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="contracts_id">Contrato Vigente</label>' +
                                '<select name="contracts_id" id="contracts_id" disabled></select>' +
                            '</div>'+
                        '</div>'+ 
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="date_of_issue">Data Emissão</label>' +
                                '<input type="date" id="date_of_issue" name="date_of_issue" value="'+$('meta[name="current-date"]').attr('content')+'">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="due_date">Data Vencimento</label>' +
                                '<input type="date" id="due_date" name="due_date">' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="value">Total do Débito</label>' +
                                '<input type="text" id="value" name="value" data="data-money">' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="form_of_payment">Metódo de Pagamento</label>' +
                                '<select name="form_of_payment" id="form_of_payment">'+
                                    '<option value="">Selecione</option>'+
                                    '<option value="1" selected>Boleto</option>'+
                                    '<option value="2">Transferência Bancária</option>'+
                                '</select>' +
                            '</div>'+
                        '</div>'+                                                    
                   '</div>'+
                   
                   '<div class="row">' +
                   
                   '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                   '<div class="form-row">' +
                       '<label for="plots">Nº de Parcelas</label>' +
                       '<input type="text" id="plots" name="plots" data="data-integrate">' +
                   '</div>'+
               '</div>'+                                                 
               '</div>'+
                   '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="costcenters_id">Centro de Custo</label>' +
                                '<select name="costcenter_id" id="costcenters_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                        '<div class="form-row">' +
                            '<label for="financialnatures_id">Natureza Financeiral</label>' +
                            '<select name="financialnature_id" id="financialnatures_id" disabled></select>' +
                        '</div>'+
                        '</div>'+
                    '</div>'+
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="accoutingitens_id">Item Contábil</label>' +
                                '<select name="accoutitem_id" id="accoutingitens_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="project_types_id">Projeto</label>' +
                                '<select name="project_type_id" id="project_types_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                    '</div>' +
                   '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text_nfe">Obs. NFS</label>' +
                                '<textarea name="text_nfe" id="text_nfe" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                 '<script>'+
                                    'CKEDITOR.replace("text_nfe", {'+
                                    'toolbarGroups: [{ name: "basicstyles", groups: [ "basicstyles", "cleanup" ] }, { name: "paragraph", groups: [ "list", "indent", "blocks", "align", "bidi", "paragraph" ] }],'+
                                    'height: 130,'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text_bank_slip">Obs. Boleto</label>' +
                                '<textarea name="text_bank_slip" id="text_bank_slip" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                '<script>'+
                                    'CKEDITOR.replace("text_bank_slip", {'+
                                    'toolbarGroups: [{ name: "basicstyles", groups: [ "basicstyles", "cleanup" ] }, { name: "paragraph", groups: [ "list", "indent", "blocks", "align", "bidi", "paragraph" ] }],'+
                                    'height: 130,'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="filter_send_billets">Enviar Boleto?</label>' +
                                '<select name="filter_send_billets" id="filter_send_billets">'+
                                '<option value="2">Não</option>'+
                                '<option value="1">Sim</option>'+
                                '</select>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="filter_send_nfse">Enviar NFSE?</label>' +
                                '<select name="filter_send_nfse" id="filter_send_nfse">'+
                                '<option value="2">Não</option>'+
                                '<option value="1">Sim</option>'+
                                '</select>' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +                                                          
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != "") {
                        $('#modal-invoice-create').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Criar Titulo');
                        $("#modal-invoice-create .content").html(_.html);

                        $(document).find('input[data="data-money"]').mask('000.000.000.000.000,00', {reverse: true});

                        _.myForm = $("#form-invoice-create").validate({
                            rules: {
                                customers_id: { required: true },
                                form_of_payment: { required: true },
                                due_date: { required: true },
                                date_of_issue: { required: true },
                                value: { required: true }
                            },
                            messages: {
                                customers_id: { required: "Campo Obrigatório" },
                                schedule_id: { required: "Campo Obrigatório" },
                                due_date: { required: "Campo Obrigatório" },
                                date_of_issue: { required: "Campo Obrigatório" },
                                value: { required: "Campo Obrigatório" }
                            },
                            invalidHandler: function(e) {
                                
                                swal({
                                    title: "Atenção!",
                                    text: "Preencha todos os campos.",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: true
                                });

                            },
                            submitHandler: function( form ) {

                                for(instance in CKEDITOR.instances) {
                                    CKEDITOR.instances[instance].updateElement();
                                }

                                $("#form-invoice-create .btn-send").html("Enviando...");
                                
                                $.ajax({
                                    type: "POST",
                                    url: _.API + "contas-a-receber/titulo/criar",
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: new FormData(form),
                                    success: function(result)
                                    { 
                                        $("#form-invoice-create .btn-send").html("Enviar");

                                        form.reset();

                                        $('#modal-invoice-create').iziModal('close'); 

                                        swal({
                                            title: result.message,
                                            text: "Click no botão para fechar!",
                                            type: "success",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: false
                                        }).then(function() {
                                          location.reload();
                                        });                                        
                                    },
                                    error: function(response) { 
                                        var errors = $.parseJSON(response.responseText);
                                        
                                        swal({
                                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                            text: "Click no botão para fechar!",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: true
                                        });

                                        $myForm.showErrors(errors);
                                        
                                        $("#form-invoice-create .btn-send").html("Enviar");
                                    }
                                });
                            }
                        });
                    }               
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-invoice-create .content").html("");
                    $('#modal-invoice-create').iziModal('setTitle', "");
                }        
            });
        }

        if($("#modal-invoice-low").length > 0) {

            $("#modal-invoice-low").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getBanckAccount();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();  
                    _.html = '<form id="form-invoice-low">'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="bank_account">Banco/Agencia/Conta:</label>' +
                                    '<select name="bank_account" id="bank_account" disabled required></select>' +
                                    '<input type="hidden" id="is_partial" name="is_partial" value="2">' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="pay_day">Data da Baixa:</label>' +
                                    '<input type="date" id="pay_day" name="pay_day" required>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+                       
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">OK <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                   '</form>';
                    $('#modal-invoice-low').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Paramentros de Baixa');
                    $("#modal-invoice-low .content").html(_.html);

                    _.myForm = $("#form-invoice-low").validate({
                        rules: {
                            filter_send_billets: { required: true },
                            filter_send_nfse: { required: true }
                        },
                        messages: {
                            filter_send_billets: { required: "Campo Obrigatório" },
                            filter_send_nfse: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Confirme os paramentros",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                            var href             = new URL(_.url);
                            $.each($('#form-invoice-low').serializeArray(), function(i, field){  
                               href.searchParams.set(field.name, field.value);   
                            }); 

                            window.location.href = href; 
                        }
                    });             
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    $("#modal-invoice-low .content").html("");
                    $('#modal-invoice-low').iziModal('setTitle', "");
                    
                }        
            });         
        } 

         if($("#modal-invoice-low-partial").length > 0) {

            $("#modal-invoice-low-partial").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading(); 
                    _.getBanckAccount(); 
                    console.log(_.url);
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();  
                    _.html = '<form id="form-invoice-low-partial">'+
                         '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="bank_account">Banco/Agencia/Conta:</label>' +
                                    '<select name="bank_account" id="bank_account" disabled required></select>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="value">Valor da Baixa:</label>' +
                                    '<input type="text" id="value" name="value" data="data-money" required>' +
                                     '<input type="hidden" id="is_partial" name="is_partial" value="1">' +
                                '</div>'+
                            '</div>'+                          
                       '</div>'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="pay_day">Data da Baixa:</label>' +
                                    '<input type="date" id="pay_day" name="pay_day" required>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+                         
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">OK <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                   '</form>';
                    $('#modal-invoice-low-partial').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Paramentros de Baixa Parcial');
                    $("#modal-invoice-low-partial .content").html(_.html);

                    $(document).find('input[data="data-money"]').mask('000.000.000.000.000,00', {reverse: true});

                    _.myForm = $("#form-invoice-low-partial").validate({
                        rules: {
                            bank_account: { required: true },
                            value: { required: true }
                        },
                        messages: {
                            bank_account: { required: "Campo Obrigatório" },
                            value: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            
                            swal({
                                title: "Atenção!",
                                text: "Confirme os paramentros",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                            var href = new URL(_.url);
                            $.each($('#form-invoice-low-partial').serializeArray(), function(index, field){  
                                href.searchParams.set(field.name, field.value);  
                            }); 

                            window.location.href = href; 
                        }
                    });             
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    $("#modal-invoice-low-partial .content").html("");
                    $('#modal-invoice-low-partial').iziModal('setTitle', "");
                    
                }        
            });         
        }

        $("a.btn-invoice-low").on("click", function(e){
            e.preventDefault();
            _.url           = $(this).attr('href');
            $('#modal-invoice-low').iziModal('open');           
        });

        $("a.btn-invoice-low-partial").on("click", function(e){
            e.preventDefault();

            if($("input[name='invoices[]']:checked").length > 1) {

                swal({
                    title: "Atenção!",
                    text: "Não é possivel a baixa parcial para mais de um titulo.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK!",
                    closeOnConfirm: true
                });

                return false;
            }

            if($("input[name='invoices[]']:checked").length == 0) {

                swal({
                    title: "Atenção!",
                    text: "Selecione um titulo.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK!",
                    closeOnConfirm: true
                });

                return false;
            }

            _.url           = $(this).attr('href');
            $('#modal-invoice-low-partial').iziModal('open');           
        });

        $("button.btn-create-invoice").on("click", function(e){
            e.preventDefault();
            $('#modal-invoice-create').iziModal('open');           
        });

        $("input#invoicesAll").on("change", function(e){
            $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
        });

        $("input[name='invoices[]']").on("change", function(e){

            if($("input[name='invoices[]']:checked").length == 0) {
                window.location.reload(true);
            }
            
            _.total(this, $(this).is(':checked'));
        });
    }

    Invoices.prototype.getCustomers = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/clientes", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#customers_id").attr('disabled', false).html(html);
            $("select#customers_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });           
        });
    };

    Invoices.prototype.getContracts = function(customers_id) {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/contratos/"+customers_id, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#contracts_id").attr('disabled', false).html(html);
            $("select#contracts_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };

    
    Invoices.prototype.getCostCenters = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/centro-de-custo", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#costcenters_id").attr('disabled', false).html(html);
            $("select#costcenters_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    Invoices.prototype.getFinancialNatures = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/natureza-financeira", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#financialnatures_id").attr('disabled', false).html(html);
            $("select#financialnatures_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };  
     
    Invoices.prototype.getAccoutingItens = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/item-contabil", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#accoutingitens_id").attr('disabled', false).html(html);
            $("select#accoutingitens_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 
      Invoices.prototype.getProjectTypes = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/tipo-de-projeto", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#project_types_id").attr('disabled', false).html(html);
            $("select#project_types_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    Invoices.prototype.getBanckAccount = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/bancos/contas", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#bank_account").attr('disabled', false).html(html);
            $("select#bank_account").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    Invoices.prototype.checkAll = function() {
        var _ =  this;
        _.oInvoices.each(function( index, value) {
           $(value).prop('checked', true);
           _.total(value, true);
        });
    };

    Invoices.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oInvoices.each(function( index, value) {
           $(value).prop('checked', false);
           window.location.reload(true);
        });
    };

    Invoices.prototype.total = function(item, isSum) {
        var _                 = this;
        var ntotal_value      = 0;
        var ntotal_value_paid = 0;
        var ntotal_value_open = 0;
        var a_invoices        = [];

        if (isSum) {
            _.total_value      += parseFloat($(item).data('total'));
            _.total_value_paid += parseFloat($(item).data('paid-total'));
            _.total_value_open += parseFloat($(item).data('opened-total'));
        } else {
            _.total_value      -= parseFloat($(item).data('total'));
            _.total_value_paid -= parseFloat($(item).data('paid-total'));
            _.total_value_open -= parseFloat($(item).data('opened-total'));
        }

        ntotal_value      = _.total_value;
        ntotal_value_paid = _.total_value_paid;
        ntotal_value_open = _.total_value_open;

        
        ntotal_value      =  ntotal_value.toFixed(2);
        ntotal_value_paid =  ntotal_value_paid.toFixed(2);
        ntotal_value_open =  ntotal_value_open.toFixed(2);

        ntotal_value      =  ntotal_value.replace('.',',');
        ntotal_value_paid =  ntotal_value_paid.replace('.',',');
        ntotal_value_open =  ntotal_value_open.replace('.',',');


        $(".title-total-value").text(ntotal_value);        
        $(".title-total-value-paid").text(ntotal_value_paid);
        $(".title-total-value-open").text(ntotal_value_open);

        $.each($("input[name='invoices[]']:checked"), function(idex, value) {
            a_invoices.push($(value).val());
        }); 

        $.each($("#links a"), function(idex, value) {
            var href  = new URL($(value).attr('href'));
            href.searchParams.set('a_invoices', a_invoices);
            $(value).attr('href', href);
        });        
    };

   	new Invoices();

}(jQuery));
 
 
 
 
